import { render } from "./seller.vue?vue&type=template&id=813a0788"
import script from "./seller.vue?vue&type=script&lang=js"
export * from "./seller.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__